import React, {useMemo}								from 'react';
import {Route, Routes}								from 'react-router-dom';

import Header										from '../Header/Header';
import Support										from './Support';
import SupportAdd									from './SupportNew';

import {useAppSelector}								from '../app/hooks';

import LANGUAGE										from '../ressources/language';


function MainSupport() {
	const supports = useAppSelector(state => state.support.data);
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	const countCurrent = useMemo(() => supports.filter(s => s.status !== 'done').length, [supports]);

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				title={TEXTE.support.title}
				badgeText={`${countCurrent} ${TEXTE.support.current}`}
			/>

			<Routes>
				<Route path={'/'} element={<Support />} />
				<Route path={'/new'} element={<SupportAdd />} />
				<Route path={'/:idSupport'} element={<Support />} />
				<Route path={'/new/:supportType/:id'} element={<SupportAdd />} />
			</Routes>
		</div>
	);
}

export default MainSupport;
